import { ScheduleLegends, ScheduleLegendType } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const CourseTypeLegends = ({
  legends,
}: {
  legends?: { id: number; name: string }[];
}) => {
  const prefix = 'scheduleLegends';
  const { t } = useTranslation();

  const scheduleLegends = useMemo<ScheduleLegendType[]>(() => {
    if (!legends) {
      return [
        { id: 1, name: t(`${prefix}.course`) },
        { id: 2, name: t(`${prefix}.assistantship`) },
        { id: 3, name: t(`${prefix}.lab`) },
        { id: 4, name: t(`${prefix}.field`) },
        { id: 5, name: t(`${prefix}.workshop`) },
        { id: 6, name: t(`${prefix}.practice`) },
        { id: 7, name: t(`${prefix}.thesis`) },
        { id: 8, name: t(`${prefix}.other`) },
        { id: 9, name: t(`${prefix}.online`), icon: 'class_online' },
        { id: 10, name: t(`${prefix}.onsite`), icon: 'class_onsite' },
      ];
    }

    return legends
      .map<ScheduleLegendType>((act) => {
        return {
          id: act.id,
          name: t(`${prefix}.${act.name}`),
        };
      })
      .concat([
        { id: 9, name: t(`${prefix}.online`), icon: 'class_online' },
        { id: 10, name: t(`${prefix}.onsite`), icon: 'class_onsite' },
      ]);
  }, [legends, t]);

  return <ScheduleLegends legends={scheduleLegends} />;
};

export default CourseTypeLegends;
